import React, { useState, useEffect, useCallback } from 'react';
import { UnavailableStub } from './UnavailableStub';

const HEALTH_CHECK_TIMEOUT_MS = 8000;
const HEALTH_CHECK_URL = '/api/v1/flights?page=1&per_page=1';

interface HealthCheckGateProps {
  children: React.ReactNode;
}

/**
 * Перед показом приложения проверяет доступность бэкенда.
 * При сетевой ошибке или таймауте показывает заглушку с кнопкой «Повторить».
 */
export const HealthCheckGate: React.FC<HealthCheckGateProps> = ({ children }) => {
  const [status, setStatus] = useState<'loading' | 'ok' | 'unavailable'>('loading');

  const check = useCallback(async () => {
    setStatus('loading');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), HEALTH_CHECK_TIMEOUT_MS);
    try {
      const res = await fetch(HEALTH_CHECK_URL, {
        credentials: 'include',
        signal: controller.signal,
      });
      clearTimeout(timeout);
      setStatus('ok');
    } catch {
      clearTimeout(timeout);
      setStatus('unavailable');
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  if (status === 'loading') {
    return (
      <div className="min-h-dvh min-h-screen flex items-center justify-center bg-gradient-to-br from-stone-200 via-stone-100 to-stone-200 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-stone-300 border-t-blue-600 dark:border-slate-600 dark:border-t-blue-500" />
      </div>
    );
  }

  if (status === 'unavailable') {
    return <UnavailableStub onRetry={check} />;
  }

  return <>{children}</>;
};

export default HealthCheckGate;
